export const COMPANY = {
  name: "EasyRohbau",
  legalName: "EasyRohbau GmbH",
  shortName: "EasyRohbau",
  tagline: "Stein für Stein zu Ihrem Heim.",
  phone: "0163 9571247",
  phoneRaw: "+491639571247",
  whatsapp: "491639571247",
  email: "info@easyrohbau.de",
  website: "www.easyrohbau.de",
  street: "Berliner Allee 59",
  postal: "40212",
  city: "Düsseldorf",
  address: "Berliner Allee 59, 40212 Düsseldorf",
  hours: "Mo–Fr 07:00–18:00",
  region: "Düsseldorf · Köln · Bonn · Leverkusen",
  founded: 2003,
};

export const SERVICES = [
  {
    slug: "rohbauarbeiten",
    title: "Rohbauarbeiten",
    short: "Komplette Rohbau-Erstellung von Fundament bis Dachgeschoss.",
    description:
      "Wir erstellen den Rohbau Ihres Bauvorhabens schlüsselfertig bis zur bezugsfähigen Hülle. Inklusive Bauleitung, Materialdisposition und termingerechter Übergabe an die Folgegewerke.",
    image: "https://images.unsplash.com/photo-1771834683942-a973fe0b5bf8?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "Building2",
    bullets: ["Schlüsselfertiger Rohbau", "Bauleitung inkl.", "Festpreisgarantie"],
  },
  {
    slug: "betonarbeiten",
    title: "Betonarbeiten",
    short: "Stahlbeton, Sichtbeton und Spezialbetone in Premium-Qualität.",
    description:
      "Von der Bewehrung bis zum Sichtbeton liefern wir präzise Betonarbeiten nach DIN 1045. Hohe Maßgenauigkeit, sortenreine Ausführung, dokumentierte Festigkeitsprüfungen.",
    image: "https://images.unsplash.com/photo-1768269378478-49d80e2320b7?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "Layers",
    bullets: ["Stahlbeton & Sichtbeton", "DIN 1045 zertifiziert", "Festigkeitsprüfung"],
  },
  {
    slug: "schalungsarbeiten",
    title: "Schalungsarbeiten",
    short: "System- und Sonderschalungen für jede Geometrie.",
    description:
      "Rahmen-, Träger- und Sonderschalungen bis zu komplexen Sichtbetonansichten. Wir planen, dimensionieren und stellen Ihre Schalungen mit modernen Systemen.",
    image: "https://images.pexels.com/photos/4458210/pexels-photo-4458210.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    icon: "Frame",
    bullets: ["Rahmen-/Trägerschalung", "Sonderschalung", "Sichtbetonklasse SB4"],
  },
  {
    slug: "fundamentarbeiten",
    title: "Fundamentarbeiten",
    short: "Streifen-, Einzel- und Plattenfundamente nach Statik.",
    description:
      "Wir erstellen Fundamente exakt nach statischer Vorgabe. Inklusive Aushub, Sauberkeitsschicht, Bewehrung und Betonage.",
    image: "https://images.unsplash.com/photo-1755290315362-6bc203937fd7?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "Anchor",
    bullets: ["Streifen-/Einzelfundamente", "Bodenplatte WU-Beton", "Aushub inkl."],
  },
  {
    slug: "mauerarbeiten",
    title: "Mauerarbeiten",
    short: "Tragende und nichttragende Wände in allen Materialien.",
    description:
      "Kalksandstein, Porenbeton, Ziegel, Beton: Wir mauern lotgenau, fugendicht und nach Vorgaben des Wärmeschutzes.",
    image: "https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "BrickWall",
    bullets: ["KS · Porenbeton · Ziegel", "Wärme-/Schallschutz", "EnEV-konform"],
  },
  {
    slug: "kellerbau",
    title: "Kellerbau",
    short: "Wasserdichte Keller in WU-Beton oder Mauerwerk.",
    description:
      "Weiße Wanne, schwarze Wanne oder klassischer Mauerwerkskeller – wir liefern wasser- und feuchtebeständige Untergeschosse.",
    image: "https://images.unsplash.com/photo-1581094794329-c8112a89af12?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "Warehouse",
    bullets: ["WU-Beton (weiße Wanne)", "Schwarze Wanne", "Lichtschächte inkl."],
  },
  {
    slug: "deckenarbeiten",
    title: "Deckenarbeiten",
    short: "Filigran-, Massiv- und Hohlkörperdecken.",
    description:
      "Wir setzen Filigrandecken effizient und montieren Massivdecken nach Statik – inklusive aller Aussparungen für die TGA.",
    image: "https://images.unsplash.com/photo-1605152276897-4f618f831968?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "SquareStack",
    bullets: ["Filigrandecke", "Massivdecke", "TGA-Aussparungen"],
  },
  {
    slug: "bodenplatten",
    title: "Bodenplatten",
    short: "Tragfähige Bodenplatten – auch als WU-Konstruktion.",
    description:
      "Aushub, Schottertragschicht, Bewehrung, Betonage – alles aus einer Hand und exakt nach Statik.",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "Square",
    bullets: ["WU-Bodenplatte", "Frostschürze", "Schottertragschicht"],
  },
  {
    slug: "sanierung",
    title: "Sanierung",
    short: "Statische Sanierung, Anbauten und Umbauten.",
    description:
      "Wir sanieren tragende Bauteile, schaffen Durchbrüche, errichten Anbauten und bringen Ihre Immobilie auf den neuesten Stand.",
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "Hammer",
    bullets: ["Tragwerkssanierung", "Wand-Durchbrüche", "Anbau / Aufstockung"],
  },
  {
    slug: "abrissarbeiten",
    title: "Abrissarbeiten",
    short: "Selektiver Rückbau und konventioneller Abbruch.",
    description:
      "Vom Teilrückbau bis zum kompletten Abriss inkl. Entsorgung und Wiederverwertung – sauber, sicher und nach KrWG.",
    image: "https://images.unsplash.com/photo-1581094651181-35942459ef62?crop=entropy&cs=srgb&fm=jpg&q=85",
    icon: "Wrench",
    bullets: ["Selektiver Rückbau", "Entsorgung inkl.", "KrWG-konform"],
  },
];

export const CITIES = [
  { slug: "koeln", name: "Köln", region: "Region Rhein-Erft", postal: "50667 – 51149" },
  { slug: "bonn", name: "Bonn", region: "Rhein-Sieg-Kreis", postal: "53111 – 53229" },
  { slug: "duesseldorf", name: "Düsseldorf", region: "Düsseldorf & Umland", postal: "40210 – 40629" },
  { slug: "leverkusen", name: "Leverkusen", region: "Rhein-Wupper", postal: "51371 – 51381" },
];

export const REFERENCES = [
  {
    id: "ref-1",
    title: "Einfamilienhaus 'Villa Rheinblick'",
    location: "Köln-Rodenkirchen",
    type: "Einfamilienhaus",
    size: "245 m²",
    duration: "5 Monate",
    year: 2025,
    image: "https://images.unsplash.com/photo-1777115470242-9b21d2c67729?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Schlüsselfertiger Rohbau inkl. WU-Keller, Filigrandecke und Sichtbeton-Treppe.",
  },
  {
    id: "ref-2",
    title: "Mehrfamilienhaus 'Quartier Süd'",
    location: "Bonn-Bad Godesberg",
    type: "Mehrfamilienhaus",
    size: "1.840 m²",
    duration: "11 Monate",
    year: 2024,
    image: "https://images.unsplash.com/photo-1486325212027-8081e485255e?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "12-Wohneinheiten Rohbau mit Tiefgarage, weißer Wanne und Stahlbeton-Tragwerk.",
  },
  {
    id: "ref-3",
    title: "Gewerbehalle 'Logistikpark Nord'",
    location: "Düsseldorf-Heerdt",
    type: "Gewerbe",
    size: "3.400 m²",
    duration: "7 Monate",
    year: 2024,
    image: "https://images.unsplash.com/photo-1565793298595-6a879b1d9492?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Stahlbeton-Skelettbau mit Sichtbetonfassade und integrierter Bürofläche.",
  },
  {
    id: "ref-4",
    title: "Sanierung 'Altbau Belgisches Viertel'",
    location: "Köln-Innenstadt",
    type: "Sanierung",
    size: "320 m²",
    duration: "4 Monate",
    year: 2025,
    image: "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Statische Ertüchtigung, neue Decken, Wanddurchbrüche – behutsame Modernisierung.",
  },
  {
    id: "ref-5",
    title: "Doppelhaus 'Park Residenz'",
    location: "Leverkusen-Schlebusch",
    type: "Einfamilienhaus",
    size: "2 × 165 m²",
    duration: "6 Monate",
    year: 2025,
    image: "https://images.unsplash.com/photo-1600585154526-990dced4db0d?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "Hochwertiger Rohbau mit Premium-Mauerwerk und WU-Bodenplatte.",
  },
  {
    id: "ref-6",
    title: "Bürogebäude 'Tech Campus'",
    location: "Köln-Mülheim",
    type: "Gewerbe",
    size: "5.200 m²",
    duration: "14 Monate",
    year: 2023,
    image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85",
    description: "5-geschossiger Stahlbeton-Bau mit Atrium und Sichtbetonelementen.",
  },
];

export const TESTIMONIALS = [
  {
    name: "Dr. Markus Hoffmann",
    role: "Bauherr Einfamilienhaus, Köln",
    quote: "Termintreue und Qualität waren herausragend. Der Rohbau stand auf den Tag genau – Festpreis ohne Nachträge.",
    rating: 5,
  },
  {
    name: "Architekturbüro Weber + Partner",
    role: "Architekt, Düsseldorf",
    quote: "Wir arbeiten seit Jahren mit EasyRohbau. Sichtbetonqualität und mitdenkende Bauleitung – kein Kompromiss.",
    rating: 5,
  },
  {
    name: "Sabrina Lehmann",
    role: "Bauträgerin MFH, Bonn",
    quote: "Ein Projekt, 12 WE, null Stress. Saubere Baustelle, klare Kommunikation, faire Abrechnung.",
    rating: 5,
  },
  {
    name: "ProjektDev GmbH",
    role: "Projektentwickler, NRW",
    quote: "Verlässlicher Partner für Gewerbeprojekte. Termin- und Kostentreue auf höchstem Niveau.",
    rating: 5,
  },
];

export const FAQS = [
  {
    q: "Wie genau ist der KI-Preisrechner?",
    a: "Unser Rechner liefert eine erste belastbare Indikation auf Basis aktueller regionaler Baupreisindizes, Materialpreise und der von Ihnen eingegebenen Parameter. Für ein verbindliches Festpreisangebot benötigen wir eine Vor-Ort-Besichtigung – diese ist kostenlos.",
  },
  {
    q: "In welcher Region sind Sie tätig?",
    a: "EasyRohbau realisiert Projekte primär in Köln, Bonn, Düsseldorf, Leverkusen und im Umkreis von ca. 80 km um Köln. Größere Vorhaben auch deutschlandweit auf Anfrage.",
  },
  {
    q: "Bauen Sie auch schlüsselfertig?",
    a: "Wir sind spezialisiert auf den Rohbau. Auf Wunsch koordinieren wir alle Folgegewerke über unser Partnernetzwerk und führen Ihr Projekt bis zur Schlüsselübergabe.",
  },
  {
    q: "Wie lange dauert ein typischer Einfamilienhaus-Rohbau?",
    a: "Bei einem Einfamilienhaus mit 150–200 m² rechnen Sie mit 4–6 Monaten ab Baubeginn – inklusive Keller, Bodenplatte, Mauerwerk, Decken und Dachgeschoss-Rohbau.",
  },
  {
    q: "Bekomme ich eine Festpreisgarantie?",
    a: "Ja. Nach der Vor-Ort-Besichtigung und Detailplanung erhalten Sie ein verbindliches Festpreisangebot ohne versteckte Nachträge.",
  },
  {
    q: "Welche Materialien verwenden Sie?",
    a: "Wir arbeiten ausschließlich mit zertifizierten Materialien (DIN-konform): Kalksandstein, Porenbeton, Ziegel, Stahlbeton C20/25–C45/55. Materialwahl in Abstimmung mit Statik und Architektur.",
  },
  {
    q: "Wie schnell startet die Baustelle nach Auftragserteilung?",
    a: "Je nach aktueller Auslastung und Witterung beginnen wir innerhalb von 4–10 Wochen mit den Arbeiten. Verbindliche Termine erhalten Sie mit Vertragsabschluss.",
  },
  {
    q: "Sind Sie versichert?",
    a: "Ja. Wir verfügen über Bauwesenversicherung, Bauhaftpflicht und Bauleistungsversicherung. Auf Wunsch erhalten Sie alle Versicherungsnachweise vor Auftragserteilung.",
  },
];

export const STATS = [
  { value: "21+", label: "Jahre Erfahrung" },
  { value: "480+", label: "realisierte Projekte" },
  { value: "98%", label: "Termintreue" },
  { value: "4.9/5", label: "Kundenbewertung" },
];

export const NAV_LINKS = [
  { to: "/", label: "Start" },
  { to: "/leistungen", label: "Leistungen" },
  { to: "/preisrechner", label: "Preisrechner" },
  { to: "/referenzen", label: "Referenzen" },
  { to: "/kontakt", label: "Kontakt" },
];
